import React from 'react'
import InputMask from 'react-input-mask'
import { TextField } from '@mui/material'
import { type SxProps, type Theme } from '@mui/material/styles'

export const PhoneNumberField: React.FC<{
  label?: string
  phoneNumber: string | null
  handlePhoneChange: (value: string) => void
  disabled: boolean
  id?: string
  name?: string
  sx?: SxProps<Theme>
}> = ({ label = 'Phone number', phoneNumber, handlePhoneChange, disabled, id, name, sx }) => {
  return (
      <InputMask
          mask="999-9999"
          placeholder="-"
          value={phoneNumber ?? ''}
          onChange={(e) => { handlePhoneChange(e.target.value) }}
          disabled={disabled}
      >
        <TextField
            id={id}
            name={name}
            label={label}
            variant="outlined"
            disabled={disabled}
            fullWidth
            sx={sx}
        />
      </InputMask>
  )
}
